import React from "react";

export const AppContext = React.createContext(
  {} // default value
);
